/* Grihvas: wishlist (hearts on every product, header link with count, wishlist page) + real low-stock line */
(function () {
  var KEY = 'gvWishlist';
  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEART = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.4-4.4-9.2-9.1C1.7 8.1 3.7 4.6 7.2 4.6c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.5 0 5.5 3.5 4.4 6.6-1.8 4.7-9.2 9.1-9.2 9.1z"/></svg>';

  function paint() {
    var list = read();
    document.querySelectorAll('[data-gv-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.gvWish) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gv-wish-count]').forEach(function (c) { c.textContent = list.length ? String(list.length) : ''; c.hidden = !list.length; });
  }

  /* capture phase so the card link / card click handlers never fire */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gv-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.dataset.gvWish, list = read(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else { list.unshift(h); b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 500); }
    write(list);
    paint();
    if (document.querySelector('[data-gv-wishlist]') && i > -1) renderPage();
  }, true);

  /* heart link with count in the header, next to the cart */
  function headerLink() {
    var actions = document.querySelector('header-actions');
    if (!actions || actions.querySelector('.gv-wish-link')) return;
    var a = document.createElement('a');
    a.className = 'gv-wish-link header-actions__action';
    a.href = root + 'pages/wishlist';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = HEART + '<span class="gv-wish-link__n" data-gv-wish-count hidden></span>';
    var cart = actions.querySelector('.action__cart, [aria-controls="cart-drawer"]');
    if (cart) actions.insertBefore(a, cart); else actions.appendChild(a);
  }

  /* wishlist page */
  function money(c) { return '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function renderPage() {
    var box = document.querySelector('[data-gv-wishlist]');
    if (!box) return;
    var grid = box.querySelector('[data-gv-wishlist-grid]'), empty = box.querySelector('[data-gv-wishlist-empty]');
    var list = read();
    if (!list.length) { grid.innerHTML = ''; empty.hidden = false; return; }
    empty.hidden = true;
    Promise.all(list.map(function (h) { return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (items) {
        var html = '';
        items.forEach(function (p) {
          if (!p) return;
          var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=500' : p.featured_image + '?width=500') : '';
          var off = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
          html += '<div class="gv-card gv-wl-card"><a class="gv-card__media" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<button type="button" class="gv-wish gv-wish--card is-on" data-gv-wish="' + esc(p.handle) + '" aria-pressed="true" aria-label="Remove ' + esc(p.title) + ' from wishlist">' + HEART + '</button>' +
            '<a class="gv-card__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
            '<span class="gv-price"><span>' + (p.price_varies ? 'From ' : '') + money(p.price) + '</span>' + off + '</span>' +
            '<a class="gv-btn gv-btn--outline" href="' + p.url + '">' + (p.available ? 'View & add to bag' : 'Sold out – view') + '</a></div>';
        });
        grid.innerHTML = html;
        if (!html) empty.hidden = false;
      });
  }

  /* real low-stock line follows the chosen pack */
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('gv-product input[name="id"][type="radio"]')) return;
    var low = document.querySelector('[data-gv-low]');
    if (!low) return;
    var q = parseInt(r.dataset.qty, 10), max = parseInt(low.dataset.max, 10) || 10;
    var show = r.dataset.available === 'true' && q > 0 && q <= max;
    low.hidden = !show;
    if (show) low.querySelector('[data-gv-low-n]').textContent = q;
  });

  function init() { headerLink(); paint(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
})();